<template>
    <div>
        <div class="boxbranco busca-pacientes-internados">
            <titulo classeAwesome="fa fa-file-text-o" nome="Histórico de Admissões" />

            <div class="row mt-3">
                <div class="form-group col">
                    <label for="cns-input">CNS</label>
                    <div class="input-group">
                        <input type="text" id="cns-input" class="form-control" v-model="cns" v-mask="'###############'">
                        <div class="input-group-append">
                            <button class="btn btn-outline-primary" type="button" @click="pesquisaCns()">Pesquisar</button>
                        </div>
                    </div>
                </div>
            </div>

            <b-alert class="mt-2" variant="danger" :show="error !== null ? true : false">
                {{error}}
            </b-alert>
        </div>

        <div class="boxbranco pacientes-internados mt-2" v-if="historico">

            <b-table
                class="mt-2"
                responsive
                striped
                bordered
                hover
                :items="historico"
                :fields="colunas"
                thead-class="tcabecario"
            >
            </b-table>

        </div>

    </div>
</template>

<script>
import Titulo from '../../shared/titulo/Titulo.vue'
export default {
    components: {
        Titulo,
    },
    data () {
        return {
            cns: '',
            colunas: [
                { key: 'nomePaciente', label: 'Nome', class: 'text-center' },
                { key: 'cnsPaciente', label: 'CNS', class: 'text-center' },
                { key: 'nomeUnidade', label: 'Unidade', class: 'text-center' },
                { key: 'dataHoraInternacao', label: 'Data/Hora da Admissão', class: 'text-center' },
                { key: 'nomeProfissionalInternacao', label: 'Profisisonal Admissão', class: 'text-center' },
                { key: 'dataHoraAlta', label: 'Data/Hora da Saída', class: 'text-center' },
                { key: 'nomeProfissionalAlta', label: 'Prosfissional Saída', class: 'text-center' },
                { key: 'motivoAlta', label: 'Motivo da Saída', class: 'text-center' }
            ],
        }
    },
    computed: {
        error () {
            return this.$store.getters['relatorios/getHistoricoInternacoesError'] 
        },
        historico () {
            return this.$store.getters['relatorios/getHistoricoInternacoes']
        },
    },
    methods: {
        pesquisaCns () {
            this.$store.dispatch('relatorios/historicoInternacoes', this.cns)
        }
    },
}
</script>

<style>
.busca-pacientes-internados {
    max-width: 620px;
    width: 96%;
    margin: 0 auto;
}

.pacientes-internados {
    max-width:1360px;
    width: 96%;
    margin: 0 auto;
}


.table th,
.table td {
  font-size: 12px!important;
  padding: 8px!important;
  vertical-align: middle!important;
}

.tcabecario {
  background-color: #f3f2f2;
}
</style>